import React from 'react';
import { DateTime } from 'luxon';
import { CellText } from '../../templates/tables/Cells';

function HistoricalDataRow({ rowId, data, cellStyles }) {
    const date = DateTime.fromISO(data.fecha).setLocale('es');
    let formattedDate = date.toFormat('d MMM yyyy');
    formattedDate = formattedDate.replace(
        /(\d+)\s(\w+)\s(\d{4})/,
        (_, day, month, year) => `${day} ${month.charAt(0).toUpperCase() + month.slice(1)} ${year}`
    );

    const formattedMonto = data.monto ? data.monto.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ' ';

    return (
        <div className={`flex-fila hoverable-row ${(rowId % 2 === 0) ? "even-row" : "uneven-row"}`} style={{ padding: '1px 0' }}>
            <div className="flex-celda" style={{ textAlign: 'center', padding: cellStyles.padding, minWidth: cellStyles.minWidth }}>
                <CellText value={formattedDate} editing={false} />
            </div>
            <div className="flex-celda" style={{ textAlign: 'center', padding: cellStyles.padding, minWidth: cellStyles.minWidth }}>
                <CellText value={formattedMonto} editing={false} />
            </div>
            <div className="flex-celda" style={{ textAlign: 'center', padding: cellStyles.padding, minWidth: cellStyles.minWidth }}>
                <CellText value={data.trm} editing={false} />
            </div>
            <div className="flex-celda" style={{ textAlign: 'center', padding: cellStyles.padding, minWidth: cellStyles.minWidth }}>
                <CellText value={data.apertura} editing={false} />
            </div>
            <div className="flex-celda" style={{ textAlign: 'center', padding: cellStyles.padding, minWidth: cellStyles.minWidth }}>
                <CellText value={data.max} editing={false} />
            </div>
            <div className="flex-celda" style={{ textAlign: 'center', padding: cellStyles.padding, minWidth: cellStyles.minWidth }}>
                <CellText value={data.min} editing={false} />
            </div>
            <div className="flex-celda" style={{ textAlign: 'center', padding: cellStyles.padding, minWidth: cellStyles.minWidth }}>
                <CellText value={data.cierre} editing={false} />
            </div>
        </div>
    );
}

export default HistoricalDataRow;
